import { Iterable } from 'immutable';
import MetaData from 'automation-ui-canvas/data/records/MetaData';
import ContactListCounts from 'automation-ui-canvas/data/records/ContactListCounts';
import ContactListIds from 'automation-ui-canvas/data/records/ContactListIds';
import EventAnchor from 'automation-ui-canvas/data/records/EventAnchor';
import AnchorSetting from 'automation-ui-canvas/data/records/AnchorSetting';
import UnenrollmentSetting from 'automation-ui-canvas/flow/records/properties/UnenrollmentSetting';
import NurtureTimeRange from 'automation-ui-canvas/data/records/NurtureTimeRange';
import ContactCounts from 'automation-ui-canvas/data/records/ContactCounts';
import RecurringSetting from 'automation-ui-canvas/data/records/RecurringSetting';
import { ActionTypeToRecord as Action } from 'automation-ui-canvas/data/records/Action';
import AuthCreds from 'automation-ui-canvas/data/records/AuthCreds';
import CreationSource from 'automation-ui-canvas/data/records/CreationSource';
import UpdateSource from 'automation-ui-canvas/data/records/UpdateSource';
import SourceApplication from 'automation-ui-canvas/data/records/SourceApplication';
import WorkflowsUser from 'automation-ui-canvas/data/records/WorkflowsUser';
import Validation from 'automation-ui-canvas/data/records/Validation';

// ZS: leaving this any since the logic in this file is
// for the classic workflows code which is almost entirely
// removed at this point
export default ((key, value) => {
  const isIndexed = Iterable.isIndexed(value);
  if (key === 'metaData') {
    return new MetaData(value);
  } else if (key === 'contactListCounts') {
    return new ContactListCounts(value);
  } else if (key === 'contactListIds') {
    return new ContactListIds(value);
  } else if (key === 'actions' && isIndexed) {
    return value
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    .map(action => new Action[action.get('type')](action)).toList();
  } else if (key === 'acceptActions' && isIndexed) {
    return value
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    .map(action => new Action[action.get('type')](action)).toList();
  } else if (key === 'rejectActions' && isIndexed) {
    return value
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    .map(action => new Action[action.get('type')](action)).toList();
  } else if (key === 'reEnrollmentTriggerSets') {
    return value.toJS();
  } else if (key === 'eventAnchor') {
    return new EventAnchor(value);
  } else if (key === 'anchorSetting') {
    return new AnchorSetting(value);
  } else if (key === 'unenrollmentSetting') {
    return new UnenrollmentSetting(value);
  } else if (key === 'nurtureTimeRange') {
    return new NurtureTimeRange(value);
  } else if (key === 'contactCounts') {
    return new ContactCounts(value);
  } else if (key === 'recurringSetting') {
    return new RecurringSetting(value);
  } else if (key === 'authCreds') {
    return new AuthCreds(value);
  } else if (key === 'creationSource') {
    return new CreationSource(value);
  } else if (key === 'updateSource') {
    return new UpdateSource(value);
  } else if (key === 'sourceApplication') {
    return new SourceApplication(value);
  } else if (key === 'createdByUser' || key === 'updatedByUser') {
    return new WorkflowsUser(value);
  } else if (key === 'validation') {
    return new Validation(value);
  }
  return isIndexed ? value.toList() : value.toMap();
});